import axios from 'axios';

/*
 * @Author: qiuz
 * @Github: <https://github.com/qiuziz>
 * @Date:  2022-09-19 11:18:48
 * @Last Modified by: qiuz
 */

/**
 * 接口响应标识
 * @see https://docs.58corp.com/#/space/1564227063819317249
 */
const SUCCESS_CODE = ['0'];
const ANTI_CODE = ['429001']; // 前后端统一标准接口规范标识

const AJK_INTERFACE_FLAG = '/ajkspec/';
const DEFAULT_CONFIG = {
  timeout: 150000,
  antiInterceptor: true
};

/*
 * @Author: qiuz
 * @Github: <https://github.com/qiuziz>
 * @Date: 2018-12-11 11:27:12
 * @Last Modified by: qiuz
 * @Last Modified time: 2022-07-28 19:23:29
 */
const isFunction = value => {
  return typeof value === 'function';
};
const isWindow = () => {
  return typeof window !== 'undefined';
};

/*
 * @Author       : gaoxiyu
 * @Date         : 2023-12-22 16:09:21
 * @LastEditTime : 2023-12-22 17:44:31
 * @LastEditors  : gaoxiyu
 */

function isScriptLoaded(domain) {
  var shouldReloadScript = true;
  var scriptTags = document.getElementsByTagName('script');

  for (var i = 0; i < scriptTags.length; i++) {
    var script = scriptTags[i];
    var src = script.getAttribute('src');
    if (!src) continue;

    if (src.indexOf(domain + '/web/api/shell.js') > -1) {
      shouldReloadScript = false;
    }
  }

  return shouldReloadScript;
}

function loadAnyaScript(options) {
  var domain = options.domain || 'aris.58.com';

  if (!isScriptLoaded(domain)) {
    return;
  }

  var script = document.createElement('script');
  var element = document.getElementsByTagName('script')[0];
  script.type = 'text/javascript';
  var uri = 'https://' + domain + '/web/api/shell.js';
  var t = Date.now();
  var d = options.os;
  var a = options.appkey;
  var v = options.version;
  script.src = uri + '?t=' + t + '&d=' + d + '&a=' + a + '&v=' + v;
  element.parentNode && element.parentNode.insertBefore(script, element);
} // {
//     appkey: '10316',
//     version: '1',
//     os: '30',
//     // 域名由设备指纹根据业务线的主域来申请或复用现有主域，请联系王旭确认
//     // 例如https://mail.58.com/接入，设备指纹这边会提前申请好aris.58.com，提供给业务
//     domain: 'anquan-security.anjuke.com'
//   }


function loadFingerPrint(options) {
  if (!isWindow()) return;

  try {
    loadAnyaScript(options);
  } catch (e) {
    // 设备指纹加载异常
    if (window.Beidou) {
      window.Beidou.captureException(new Error(`设备指纹加载异常: ${e}`), {
        tags: {
          appkey: options.appkey || '',
          address: window.location.href
        }
      });
    }
  }
}

/*
 * @Author       : gaoxiyu
 * @Date         : 2023-12-22 19:10:24
 * @LastEditTime : 2023-12-22 19:24:44
 * @LastEditors  : gaoxiyu
 */

function loadFzqScript() {
  if (window.fzq_init) return;
  var script = document.createElement('script');
  var element = document.getElementsByTagName('script')[0];
  script.type = 'text/javascript';
  script.crossOrigin = 'anonymous';
  var uri = '//callback.58.com/sdk/ptzf.js';
  script.src = uri;
  element.parentNode && element.parentNode.insertBefore(script, element);
}

function loadFzq() {
  if (!isWindow()) return;

  try {
    loadFzqScript();
  } catch (e) {
    // 设备指纹加载异常
    if (window.Beidou) {
      window.Beidou.captureException(new Error(`加密令牌加载异常: ${e}`), {
        tags: {
          address: window.location.href
        }
      });
    }
  }
}

/*
 * @Author       : gaoxiyu
 * @Date         : 2024-01-11 18:59:37
 * @LastEditTime : 2024-01-11 18:59:39
 * @LastEditors  : gaoxiyu
 */
const sleep = function (n) {
  if (n === void 0) {
    n = 750;
  }

  return new Promise(r => setTimeout(r, n));
};

/**
 * 前后端统一规范 处理
 * @see https://docs.58corp.com/#/space/1564227063819317249
 * @param response
 * @returns response
 */

const AjkspecResponseInterceptor = response => {
  const {
    status,
    data = {},
    config = {}
  } = response || {};
  const {
    url = ''
  } = config || {};
  const {
    status: dataStatus,
    code
  } = data || {};

  if (url && url.includes(AJK_INTERFACE_FLAG)) {
    if (status && status === 200) {
      const resultCode = `${dataStatus || code}`;

      if (SUCCESS_CODE.indexOf(resultCode) > -1) {
        return Promise.resolve(response);
      }

      return Promise.reject(response);
    }

    return Promise.reject(response);
  }

  return response;
};
/**
 * 错误处理 - 反爬处理
 * @param res AjkAxiosResponse
 */

const codeErrorHandle = res => {
  const {
    data = {},
    config = {}
  } = res || {};
  const {
    status,
    code,
    data: businessData = {}
  } = data || {};
  const {
    verify_url
  } = businessData;
  const {
    antiHitHandle
  } = config || {};
  const resultCode = `${status || code}`;

  switch (resultCode) {
    // 命中反爬
    case '429001':
      if (antiHitHandle && isFunction(antiHitHandle)) {
        antiHitHandle(res);
      } else {
        verify_url && (window.location.href = verify_url);
      }

      break;
  }
};
/**
 * 反爬响应拦截器
 * @param response
 * @returns
 */


const AntiResponseInterceptor = response => {
  const {
    status,
    data = {},
    config = {}
  } = response || {};
  const {
    url = ''
  } = config || {}; // 不符合规范的接口不进行处理

  if (url && url.includes(AJK_INTERFACE_FLAG)) return response;
  const {
    status: dataStatus,
    code
  } = data || {};

  if (status && status === 200) {
    const resultCode = `${dataStatus || code}`;

    if (ANTI_CODE.indexOf(resultCode) > -1) {
      codeErrorHandle(response);
      return Promise.reject(response);
    }

    return Promise.resolve(response);
  }

  return Promise.reject(response);
};
/**
 * 错误处理 统一抛出
 * @param error
 * @returns
 */

const ErrorInterceptor = error => {
  return Promise.reject(error);
};
const RetryInterceptor = async error => {
  const {
    config = {}
  } = error || {};
  const {
    __retryCount = 0,
    retryDelay = 300,
    retryTimes
  } = config || {};
  if (!retryTimes) return Promise.reject(error); // 在请求对象上设置重试次数

  config.__retryCount = __retryCount; // 判断是否超过了重试次数

  if (__retryCount >= retryTimes) {
    return Promise.reject(error);
  } // 增加重试次数


  config.__retryCount++; // 延时处理

  const delay = new Promise(resolve => {
    setTimeout(() => {
      resolve({});
    }, retryDelay);
  }); // 重新发起请求

  await delay;
  return await instance(config);
};
/**
 * 指纹拦截器
 * @param request
 * @returns
 */

const FingerPrintInterceptor = request => {
  if (!isWindow()) return request;
  if (!fingerPrintConfig.isInit) return request; // 是否初始化进行检测

  if (!fingerPrintConfig.methods.includes(request.method || '')) return request;
  if (fingerPrintConfig.whileListReg.some(item => item.test(request.url || ''))) return request; // 白名单检测
  // 万一有些人传了个大写的, 如果有bbid，则跳过

  if (request.headers && (request.headers.xxzlbbid || request.headers.Xxzlbbid)) return request;

  try {
    // 如果白名单通过
    const xxzlbbid = window.Anya && window.Anya.getBBid ? window.Anya.getBBid() : 'no anya';

    if (request.headers) {
      request.headers['xxzlbbid'] = xxzlbbid;
    } else {
      request.headers = {
        xxzlbbid: xxzlbbid
      };
    }

    if (window.Anya && xxzlbbid === 'no anya') {
      throw new Error('getBBid 读取异常，结果为 no anya');
    }
  } catch (e) {
    if (window.Beidou) {
      window.Beidou.captureException(new Error(`设备指纹获取异常: ${e}`), {
        tags: {
          appkey: fingerPrintConfig.appkey || '',
          address: window.location.href,
          url: request.url
        }
      });
    }
  }

  return request;
};

const getToken = () => new Promise(resolve => {
  const URL_ORIGIN = window.location.origin || `${window.location.protocol}//${window.location.hostname}`;
  return window.fzq_init(fzqConfig.namespace, URL_ORIGIN, (fzqQ, fzqH) => resolve({
    fzqQ,
    fzqH
  }));
}).catch(e => {
  if (window.Beidou) {
    window.Beidou.captureException(new Error(`加密令牌获取异常: ${e}`), {
      tag: {
        address: window.location.href
      }
    });
  }

  return Promise.resolve({
    fzqQ: '',
    fzqH: ''
  });
});

const FzqInterceptor = async request => {
  if (!isWindow()) return request;
  if (!fzqConfig.isInit) return request; // 是否初始化进行检测

  if (fzqConfig.whileListReg.some(item => item.test(request.url || ''))) return request; // 白名单检测

  if (!fzqConfig.methods.includes(request.method || '')) return request;
  const staticValue = request.params && request.params.staticValue || request.data && request.data.staticValue; // 如果已经传入了静态令牌，就认为已经有fzq了, 跳过

  if (window.fzq_init && !staticValue) {
    const data = await Promise.race([sleep(150), getToken()]);
    if (!data) return request;

    if (request.method === 'get' || request.method === 'options') {
      if (request.params) {
        request.params.staticValue = data.fzqH;
        request.params.dynamicValue = data.fzqQ;
        request.params.namespace = fzqConfig.namespace;
      } else {
        request.params = {
          staticValue: data.fzqH,
          dynamicValue: data.fzqQ,
          namespace: fzqConfig.namespace
        };
      }
    } else {
      if (request.data) {
        request.data.staticValue = data.fzqH;
        request.data.dynamicValue = data.fzqQ;
        request.data.namespace = fzqConfig.namespace;
      } else {
        request.data = {
          staticValue: data.fzqH,
          dynamicValue: data.fzqQ,
          namespace: fzqConfig.namespace
        };
      }
    }

    return request;
  }

  return request;
};

/*
 * @Author: qiuz
 * @Github: <https://github.com/qiuziz>
 * @Date:  2022-07-28 16:56:55
 * @Last Modified by: qiuz
 */
const instance = /*#__PURE__*/axios.create();
const antiResponseHandle = [AntiResponseInterceptor, ErrorInterceptor];
const ajkspecResponseHandle = [AjkspecResponseInterceptor, ErrorInterceptor];
const retryResponseHandle = [undefined, RetryInterceptor];
const fingerPrintRequestHandle = [FingerPrintInterceptor, ErrorInterceptor];
const fzqRequestHandle = [FzqInterceptor, ErrorInterceptor]; // 在导出的默认实例上注册反爬拦截器、接口规范标准拦截器

instance.interceptors.response.use(...antiResponseHandle);
instance.interceptors.response.use(...ajkspecResponseHandle);
instance.interceptors.response.use(...retryResponseHandle);
instance.interceptors.request.use(...fingerPrintRequestHandle);
instance.interceptors.request.use(...fzqRequestHandle); // 重写axios实例的create 在创建axios实例时注册反爬拦截器、接口规范标准拦截器

instance.create = config => {
  const axiosConfig = { ...DEFAULT_CONFIG,
    ...(config || {})
  };
  const {
    antiInterceptor = true
  } = axiosConfig;
  const ins = axios.create(config);

  if (antiInterceptor) {
    ins.interceptors.response.use(...antiResponseHandle);
  }

  ins.interceptors.response.use(...ajkspecResponseHandle);
  ins.interceptors.response.use(...retryResponseHandle);
  ins.interceptors.request.use(...fingerPrintRequestHandle);
  ins.interceptors.request.use(...fzqRequestHandle);
  return ins;
};
const fingerPrintConfig = {
  domain: '',
  os: '',
  appkey: '',
  version: '',
  methods: ['get', 'post'],
  isInit: false,
  whileList: [],
  whileListReg: []
};
const setFingerPrintConfig = options => {
  fingerPrintConfig.isInit = true;
  fingerPrintConfig.domain = options && options.domain || fingerPrintConfig.domain || 'anquan-security.anjuke.com';
  fingerPrintConfig.os = options && options.os || fingerPrintConfig.os || '30';
  fingerPrintConfig.appkey = options && options.appkey || fingerPrintConfig.appkey || '';
  fingerPrintConfig.version = options && options.version || fingerPrintConfig.version || '';
  fingerPrintConfig.methods = options && options.methods || fingerPrintConfig.methods || ['get', 'post'];
  fingerPrintConfig.whileList = options && options.whileList || fingerPrintConfig.whileList || [];
  fingerPrintConfig.whileListReg = fingerPrintConfig.whileList.map(item => new RegExp(item, 'ig'));
  loadFingerPrint(fingerPrintConfig);
};
const fzqConfig = {
  namespace: 'jjr_b_pc_gy',
  methods: ['get', 'post'],
  isInit: false,
  whileList: [],
  whileListReg: []
};
const setFzqConfig = options => {
  fzqConfig.isInit = true;
  fzqConfig.namespace = options && options.namespace || fzqConfig.namespace || 'firewall_test';
  fzqConfig.methods = options && options.methods || fzqConfig.methods || ['get', 'post'];
  fzqConfig.whileList = options && options.whileList || fzqConfig.whileList || [];
  fzqConfig.whileListReg = fzqConfig.whileList.map(item => new RegExp(item, 'ig'));
  loadFzq();
};

export default instance;
export { FingerPrintInterceptor, FzqInterceptor, fingerPrintConfig, fzqConfig, setFingerPrintConfig, setFzqConfig };
//# sourceMappingURL=network.esm.js.map
